/** Audibility facts only: identity facts (JOINED, LEFT, KICKED) belong to the API. */
export enum AudioDeviceFactType {
  STREAM_STARTED = 'STREAM_STARTED',
  STREAM_STOPPED = 'STREAM_STOPPED',
  CONNECTION_LOST = 'CONNECTION_LOST',
}
